<template>
  <UiText
    :text="$tc('regAuthForgot.labels.or')"
    font="body-heading-5"
    color="neutral-500"
    align-center
    class="registration-block__text custom-scrollbar__label"
  />
</template>

<script>
export default {
  name: 'RegAuthOr',
}
</script>

<style lang="scss" scoped>
.registration-block__text {
  position: relative;
  overflow: hidden;
  margin-top: var(--spaces-l);
  &:before,
  &:after {
    position: absolute;
    top: 50%;
    height: 1px;
    transform: translateY(-50%);
    background-color: var(--neutral-600);
    width: 50%;
    content: '';
  }
  &:before {
    left: -24px;
  }
  &:after {
    right: -24px;
  }
}
</style>
